import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ['item']

  toggle (event) {
    if (event) {
      event.preventDefault()
    }

    this.itemTargets.forEach(item => {
      item.classList.toggle('hidden')
    })
  }
}
